import React from 'react';
import { Skeleton, SkeletonSquare } from '@fiverr-private/feedback';
import { spacing40 } from '@fiverr-private/sass/helpers';

import classes from './InspireCarouselCardSkeleton.module.scss';

const height = spacing40 * 1.5; // must be the same as InspireCard's $carousel_variant_height
const heightLg = spacing40 * 2; // must be the same as InspireCard's $carousel_variant_height_lg

export const InspireCarouselCardSkeleton = () => (
  <div className={classes.container}>
    <Skeleton width="auto">
      <div className={classes.lgDown}>
        <SkeletonSquare width="auto" height={height} />
      </div>
      <div className={classes.lgUp}>
        <SkeletonSquare width="auto" height={heightLg} />
      </div>
    </Skeleton>
  </div>
);
